import React from 'react'
// import CIcon from '@coreui/icons-react'
// import {
//   cilBell,
//   cilCalculator,
//   cilChartPie,
//   cilCursor,
//   cilDrop,
//   cilNotes,
//   cilPencil,
//   cilPuzzle,
//   cilSpeedometer,
//   cilStar,
// } from '@coreui/icons'
// const URL = window.location.href
// const result = URL.split('/').pop()
// const port = window.location.protocol == 'http:' ? ':8585/' : ':8586/'
// const Testport = window.location.protocol == 'http:' ? ':81/' : ':444/'
const host = window.location.host
const host1 = host.split(':')
const config = {
  // IP: 'localhost',
  // URL: 'http://localhost:13941/',
  // IP: 'rfi.msystechnologies.com',
  // URL: window.location.protocol + '//rfi.msystechnologies.com' + Testport + 'rfi/',
  // IP: 'rfi.msystechnologies.com',
  // URL: window.location.protocol + '//rfi.msystechnologies.com' + port,
  IP: 'rfi.msystechnologies.com',
  //URL: 'http://192.168.100.15/hrmsapi', //VBL
  //URL: 'http://hr.zyplesoft.com/hrmsapi', //Zyple
  //URL: 'http://'+host1[0]+'/hrmsapi', //Zyple
 //URL: 'https://'+host1[0]+':82/hrmsapi', //ABS india
  //URL: 'http://'+host1[0]+':85/hrmsapi', //ABS india
URL: 'https://empclaims.absindia.net:82/hrmsapi',                           //ABS indai live
  //URL:'http://'+host1[0]+'/hrmsapidemo',//Zyple Demo
 // URL: 'http://'+host1[0]+':81/hrmsapi' //RAK
  //URL: 'http://122.166.66.243:81/hrmsapi' //RAK
 //URL: 'http://'+host1[0]+':83/hrmsapi' //RAK SK
  //URL: 'http://122.166.66.243:83/hrmsapi' //RAK SK
  //URL: 'https://paysoft.microtechcnc.in:9004/hrmsapi' //Microtech
// URL: 'http://localhost:1001'
//URL: 'http://192.168.1.6:85/hrmsapi'
}
export default config